import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvChipComponent } from '@devinco/ui/dds';

@Component({
  selector: 'app-chip',
  imports: [DvChipComponent],
  templateUrl: './chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chip.component.scss',
})
export class ChipComponent implements AfterViewInit {
  label = input<string>('');
  remove = output<void>();
  color = input<'negative' | 'positive' | 'neutral' | 'notice'>('negative');
  colorToken = input<string>();

  @ViewChild('chip', { read: ElementRef }) chip!: ElementRef;

  ngAfterViewInit(): void {
    if (this.colorToken()) {
      const dvChip = this.chip.nativeElement.firstElementChild;
      const classList: string[] = dvChip.classList || [];
      classList.forEach(item => {
        if (item !== 'dv-chip') {
          dvChip.classList.remove(item);
        }
      });
      dvChip.classList.add('custom');
      dvChip.style['background-color'] = `var(${this.colorToken()})`;
      dvChip.style.color = 'var(--dv-base-white)';
    }
  }
}
